export const queryConfig = {
    common: {
        errors: {
            notFound: 'Common.NotFound',
            serverError: 'Common.ServerError',
            unauthorized: 'Common.Unauthorized',
            forbidden: 'Common.Forbidden',
            badRequest: 'Common.BadRequest',
            unknownError: 'Common.UnknownError',
        },
    },
    auth: {
        forgotPassword: {
            endpoint: 'Identity/ForgotPassword',
            queryKey: 'ForgotPassword',
        },
        setPassword: {
            endpoint: 'Identity/SetPassword',
            queryKey: 'SetPassword',
        },
        twoFactorLogin: {
            endpoint: 'Identity/TwoFactorLogin',
            queryKey: 'TwoFactorLogin',
        },
        completeMigration: {
            endpoint: 'Identity/CompleteMigration',
            queryKey: 'CompleteMigration',
        },
        refreshToken: {
            endpoint: 'Identity/RefreshToken',
            queryKey: 'RefreshToken',
        },
        endpoints: {
            login: 'Identity/Login',
            token: 'Tokens/Token',
            register: 'Identity/Register',
            loginTwoFactor: 'Identity/LoginTwoFactor',
            completeMigration: 'Identity/CompleteMigration',
            refreshToken: 'Identity/RefreshToken',
            currentUser: 'Identity/CurrentUser',
            myInformation: 'Identity/MyInformation',
            tenants: 'Identity/Tenants',
            singUp: 'Identity/RegisterGetLink',
            registrationConfirm: 'Identity/RegisterConfirm',
        },
        queryKeys: {
            login: 'Identity/Login',
            token: 'Tokens/Token',
            register: 'Register',
            loginTwoFactor: 'LoginTwoFactor',
            completeMigration: 'CompleteMigration',
            refreshToken: 'RefreshToken',
            myInformation: 'Identity/MyInformation',
            tenants: 'Identity/Tenants',
            singUp: 'Identity/RegisterGetLink',
            registrationConfirm: 'Identity/RegisterConfirm',
        },
        storageKeys: {
            token: 'auth_token',
            refreshToken: 'auth_refresh_token',
            tokenExpirationDate: 'auth_token_expiration_date',
        },
        errors: {
            invalidUserNameOrPassword: 'Login.InvalidPassword',
            notAllowed: 'Login.NotAllowed',
            userDoesntHaveEmail: 'Login.UserDoesntHaveEmail',
            userLockedOut: 'Login.UserLockedOut',
        },
    },
    features: {
        apartments: {
            queryKeys: {
                list: 'ApartmentsList',
                details: 'ApartmentDetails',
                apartmentsLookup: 'ApartmentsLookup',
            },
            endpoints: {
                list: 'Apartments',
                get: 'Apartments',
                apartmentsLookup: 'Apartments/Lookup',
            },
        },
        calendar: {
            queryKeys: {
                list: 'CalendarEventsList',
                details: 'CalendarEventDetails',
            },
            endpoints: {
                list: 'Calendar',
            },
        },
        dashboard: {
            queryKeys: {
                income: 'Income',
                adr: 'ADR',
                occupancyRate: 'Occupancy Rate',
                totalApartments: 'Total Apartments',
                managedBy: 'Managed By',
                totalOwners: 'Total Owners',
                recentEvents: 'Recent Events',
                recentTransactions: 'Recent Transactions',
                recentOrders: 'Recent Orders',
            },
            endpoints: {
                income: 'Dashboard/Income',
                adr: 'Dashboard/ADR',
                occupancyRate: 'Dashboard/OccupancyRate',
                totalApartments: 'Dashboard/TotalApartments',
                managedBy: 'Dashboard/ManagedBy',
                totalOwners: 'Dashboard/TotalOwners',
                recentEvents: 'Dashboard/RecentEvents',
                recentTransactions: 'Dashboard/RecentTransactions',
                recentOrders: 'Dashboard/RecentOrders',
            },
        },
        owners: {
            permissions: {
                get: {
                    endpoint: 'Owners/{ownerId}/Permissions',
                    queryKey: 'OwnersPermissions',
                },
                setShowCalendar: {
                    endpoint: 'Owners/{{ownerId}}/SetShowCalendar/{value}',
                    queryKey: 'OwnersSetShowCalendar',
                },
                setShowFinances: {
                    endpoint: 'Owners/{ownerId}/SetShowFinances/{value}',
                    queryKey: 'OwnersSetShowFinances',
                },
                setCreateBookings: {
                    endpoint: 'Owners/{ownerId}/SetCreateBookings/{value}',
                    queryKey: 'OwnersSetCreateBookings',
                },
                setPlaceOrders: {
                    endpoint: 'Owners/{ownerId}/SetPlaceOrders/{value}',
                    queryKey: 'OwnersSetPlaceOrders',
                },
                setLoginToAccount: {
                    endpoint: 'Owners/{ownerId}/SetLoginToAccount/{value}',
                    queryKey: 'OwnersSetLoginToAccount',
                },
                setBookingDurationLimits: {
                    endpoint: 'Owners/{ownerId}/SetBookingDurationLimits/{value}',
                    queryKey: 'OwnersSetBookingDurationLimits',
                },
                setYearlyBookingLimit: {
                    endpoint: 'Owners/{ownerId}/SetYearlyBookingLimit/{value}',
                    queryKey: 'OwnersSetYearlyBookingLimit',
                },
                myList: {
                    endpoint: 'Owners/MyPermissions',
                    queryKey: 'OwnersMyPermissions',
                },
            },
            queryKeys: {
                list: 'OwnersList',
                details: 'OwnerDetails',
                ownersLookup: 'OwnersLookup',
                sendInvitation: 'SendInvitationEmail',
                notInvitedOwnersList: 'NotInvitedOwners',
            },
            endpoints: {
                list: 'Owners',
                get: 'Owners',
                ownersLookup: 'Owners/Lookup',
                sendInvitation: 'Owners/SendInvitationEmail/{ownerId}',
                notInvitedOwnersList: 'Owners/GetNotInvited',
            },
        },
        reservations: {
            queryKeys: {
                list: 'ReservationsList',
                details: 'ReservationDetails',
            },
            endpoints: {
                list: 'Reservations',
                get: 'Reservations',
                create: 'Reservations',
                update: 'Reservations',
                cancel: 'Reservations/{id}/Cancel',
            },
        },
        accommodations: {
            queryKeys: {
                details: 'AccommodationDetails',
            },
            endpoints: {
                get: 'Accommodations/{accommodationId}/{apartmentId}',
            },
        },
        accounts: {
            queryKeys: {
                details: 'AccountProfileDetails',
                balance: 'AccountBalance',
                myProfile: 'Accounts/MyProfile',
                twoFactorAuth: 'Accounts/TwoFactorAuth',
            },
            endpoints: {
                get: 'Accounts/Profile',
                balance: 'Accounts/MyBalance',
                myProfile: 'Accounts/MyProfile',
                getTwoFactorAuthCode: 'Accounts/SetTwoFactorAuthGetCode',
                setTwoFactorAuth: 'Accounts/SetTwoFactorAuth',
            },
        },
        identity: {
            queryKeys: {
                details: 'MyInformationDetails',
            },
            endpoints: {
                get: 'Identity/MyInformation',
                changeAvatar: 'Identity/ChangeAvatar',
                removeAvatar: 'Identity/RemoveAvatar',
            },
        },
        settings: {
            queryKeys: {
                details: 'SettingsDetails',
            },
            endpoints: {
                get: 'Accounts/Settings',
                update: 'Accounts/Settings',
                uploadLogo: 'Accounts/Settings/Logo',
                updatePassword: 'Identity/UpdatePassword',
            },
        },
        paymentSettings: {
            queryKeys: {
                details: 'PaymentSettingsDetails',
            },
            endpoints: {
                get: 'Accounts/PaymentSettings',
                update: 'Accounts/PaymentSettings',
            },
        },
        newsAndOffers: {
            queryKeys: {
                list: 'NewsAndOffersList',
                details: 'NewAndOfferDetails',
            },
            endpoints: {
                list: 'NewsAndOffers',
                get: 'NewsAndOffers',
                create: 'NewsAndOffers',
                update: 'NewsAndOffers',
                delete: 'NewsAndOffers',
                createImage: 'NewsAndOffers/UploadImage',
                changeStatus: 'NewsAndOffers/ChangeStatus',
            },
        },
        orders: {
            queryKeys: {
                list: 'OrdersList',
                details: 'OrderDetails',
                orderServices: 'OrderServices',
                orderItems: 'OrderItems',
                orderApartmentsLookup: 'OrderApartmentsLookup',
                orderAuthorsLookup: 'OrderAuthorsLookup',
                orderServicesLookup: 'OrderServicesLookup',
            },
            endpoints: {
                list: 'Orders',
                get: 'Orders',
                create: 'Orders',
                update: 'Orders',
                delete: 'Orders',
                pay: 'Orders',
                orderServices: 'Orders/OrderServices',
                orderItems: 'Orders/OrderItems',
                orderApartmentsLookup: 'Orders/ApartmentsLookup',
                orderAuthorsLookup: 'Orders/AuthorsLookup',
                orderServicesLookup: 'Orders/ServicesLookup',
            },
        },
        hotels: {
            queryKeys: {
                list: 'HotelsList',
                apiRefresh: 'ApiRefresh',
            },
            endpoints: {
                list: 'Hotels',
            },
        },
        finances: {
            queryKeys: {
                balance: 'FinanceBalance',
                balanceSummary: 'FinanceBalanceSummary',
                analytics: 'FinanceAnalytics',
                analyticsMonthly: 'FinanceAnalyticsMonthly',
                rentAnalyticsExpenseVisibility: 'FinanceRentAnalyticsExpenseVisibility',
                transactions: 'FinanceTransactions',
            },
            endpoints: {
                balance: 'Finance/Balance',
                balanceSummary: 'Finance/BalanceSummary',
                analytics: 'Finance/Analytics',
                analyticsMonthly: 'Finance/AnalyticsMonthly',
                rentAnalyticsExpenseVisibility: 'Finance/RentAnalyticsExpenseVisibility',
                transactions: 'Finance/Transactions',
            },
        },
        transactions: {
            queryKeys: {
                list: 'TransactionsList',
                details: 'TransactionDetails',
            },
            endpoints: {
                list: 'Transactions',
                get: 'Transactions',
                downloadInvoices: 'Transactions/DownloadInvoices',
            },
        },
        notifications: {
            queryKeys: {
                adminList: 'NotificationsList',
                ownerList: 'MyNotificationsList',
                details: 'NotificationDetails',
            },
            endpoints: {
                adminList: 'Notifications',
                ownerList: 'Notifications/MyNotifications',
                get: 'Notifications',
                create: 'Notifications',
                update: 'Notifications',
                bulkMarkAsRead: 'Notifications/BulkMarkAsRead',
            },
        },
        faq: {
            queryKeys: {
                list: 'FaqList',
                details: 'FaqDetails',
            },
            endpoints: {
                list: 'Faq',
                get: 'Faq',
                create: 'Faq',
                update: 'Faq',
                delete: 'Faq',
                updateIndex: 'Faq',
            },
        },
        releases: {
            queryKeys: {
                list: 'WhatsNewList',
                details: 'WhatsNewDetails',
                latest: 'WhatsNewLatest',
            },
            endpoints: {
                latest: 'WhatsNew/GetLatestNews',
                markRead: 'WhatsNew/MarkRead',
                list: 'WhatsNew',
                get: 'WhatsNew/{id}',
                create: 'WhatsNew',
                update: 'WhatsNew/{id}',
                delete: 'WhatsNew/{id}',
                send: 'WhatsNew/SendNews/{id}',
            },
        },
    },
    superAdmin: {
        dashboard: {
            queryKeys: {
                userActivityChart: 'SuperAdmin/Dashboard/GetUserActivityChart',
                userActivityList: 'SuperAdmin/Dashboard/GetUserActivityList',
            },
            endpoints: {
                userActivityChart: 'SuperAdmin/Dashboard/GetUserActivityChart',
                userActivityList: 'SuperAdmin/Dashboard/GetUserActivityList',
            },
        },
        tenants: {
            queryKeys: {
                list: 'SuperAdmin/TenantsList',
                selectOptions: 'SuperAdmin/TenantsSelectOptions',
                details: 'SuperAdmin/TenantDetails',
                demoSeedAvailability: 'SuperAdmin/TenantDemoSeedAvailability',
                databaseBackup: 'SuperAdmin/DatabaseBackup',
            },
            endpoints: {
                list: 'SuperAdmin/Tenants',
                get: 'SuperAdmin/Tenants/{id}',
                create: 'SuperAdmin/Tenants',
                update: 'SuperAdmin/Tenants/{id}',
                delete: 'SuperAdmin/Tenants/{id}',
                seedDemoDataAvailability: 'SuperAdmin/Tenants/seed-demo-data/availability',
                seedDemoData: 'SuperAdmin/Tenants/{id}/seed-demo-data',
                uploadLogo: 'SuperAdmin/Tenants/{id}/Logo',
                createDatabaseBackup: 'SuperAdmin/Tenants/database-backup',
                downloadDatabaseBackup: 'SuperAdmin/Tenants/database-backup/{backupId}/download',
            },
        },
        users: {
            queryKeys: {
                list: 'SuperAdmin/UsersList',
                details: 'SuperAdmin/UserDetails',
                sendInvitationEmail: 'SuperAdmin/SendUserInvitationEmail',
                sendInvitationEmailToAll: 'SuperAdmin/SendUserInvitationEmailToAll',
                resetPasswords: 'SuperAdmin/ResetPasswords',
            },
            endpoints: {
                list: 'SuperAdmin/Users',
                export: 'SuperAdmin/Users/export',
                get: 'SuperAdmin/Users/{id}',
                create: 'SuperAdmin/Users',
                update: 'SuperAdmin/Users/{id}',
                sendInvitationEmail: 'SuperAdmin/Users/{id}/SendInvitationEmail',
                sendInvitationEmailToAll: 'SuperAdmin/Users/SendInvitationEmailToAllOwners',
                resetPasswords: 'SuperAdmin/Users/ResetPasswords',
                impersonate: 'SuperAdmin/Users/{id}/Impersonate',
                setPassword: 'SuperAdmin/Users/{id}/SetPassword',
                sendPasswordRecoveryEmail: 'SuperAdmin/Users/{id}/SendPasswordRecoveryEmail',
            },
        },
        userActivities: {
            queryKeys: {
                list: 'SuperAdmin/UserActivitiesList',
            },
            endpoints: {
                list: 'SuperAdmin/UserActivities',
            },
        },
        supportEmailRequests: {
            queryKeys: {
                list: 'SupportEmailRequestsList',
                detail: 'SupportEmailRequestDetail',
            },
            endpoints: {
                list: 'SupportEmailRequests',
                get: 'SupportEmailRequests',
                create: 'SupportEmailRequests',
                update: 'SupportEmailRequests',
                delete: 'SupportEmailRequests',
                analyze: 'SupportEmailRequests',
            },
        },
        platformSettings: {
            queryKeys: {
                get: 'SuperAdmin/PlatformSettings',
            },
            endpoints: {
                get: 'SuperAdmin/PlatformSettings',
                update: 'SuperAdmin/PlatformSettings',
            },
        },
        aiSettings: {
            queryKeys: {
                get: 'SuperAdmin/AiSettings',
            },
            endpoints: {
                get: 'SuperAdmin/AiSettings',
                update: 'SuperAdmin/AiSettings',
            },
        },
        integrationMessages: {
            messageTypes: {
                queryKeys: {
                    get: 'SuperAdmin/IntegrationMessageTypes',
                },
                endpoints: {
                    get: 'SuperAdmin/IntegrationMessages/types',
                },
            },
            inbox: {
                queryKeys: {
                    list: 'SuperAdmin/InboxMessagesList',
                    detail: 'SuperAdmin/InboxMessageDetail',
                },
                endpoints: {
                    list: 'SuperAdmin/InboxMessages',
                    get: 'SuperAdmin/InboxMessages',
                    update: 'SuperAdmin/InboxMessages',
                    delete: 'SuperAdmin/InboxMessages',
                    bulkDelete: 'SuperAdmin/InboxMessages/bulk-delete',
                    purgeProcessed: 'SuperAdmin/InboxMessages/purge-processed',
                    purgeAll: 'SuperAdmin/InboxMessages/purge-all',
                },
            },
            outbox: {
                queryKeys: {
                    list: 'SuperAdmin/OutboxMessagesList',
                    detail: 'SuperAdmin/OutboxMessageDetail',
                },
                endpoints: {
                    list: 'SuperAdmin/OutboxMessages',
                    get: 'SuperAdmin/OutboxMessages',
                    update: 'SuperAdmin/OutboxMessages',
                    delete: 'SuperAdmin/OutboxMessages',
                    bulkDelete: 'SuperAdmin/OutboxMessages/bulk-delete',
                    purgeProcessed: 'SuperAdmin/OutboxMessages/purge-processed',
                    purgeAll: 'SuperAdmin/OutboxMessages/purge-all',
                },
            },
            internalOutbox: {
                queryKeys: {
                    list: 'SuperAdmin/InternalOutboxMessagesList',
                    detail: 'SuperAdmin/InternalOutboxMessageDetail',
                },
                endpoints: {
                    list: 'SuperAdmin/InternalOutboxMessages',
                    get: 'SuperAdmin/InternalOutboxMessages',
                    update: 'SuperAdmin/InternalOutboxMessages',
                    delete: 'SuperAdmin/InternalOutboxMessages',
                    bulkDelete: 'SuperAdmin/InternalOutboxMessages/bulk-delete',
                    purgeProcessed: 'SuperAdmin/InternalOutboxMessages/purge-processed',
                    purgeAll: 'SuperAdmin/InternalOutboxMessages/purge-all',
                },
            },
            emailOutbox: {
                queryKeys: {
                    list: 'SuperAdmin/EmailOutboxMessagesList',
                    detail: 'SuperAdmin/EmailOutboxMessageDetail',
                },
                endpoints: {
                    list: 'SuperAdmin/EmailOutboxMessages',
                    get: 'SuperAdmin/EmailOutboxMessages',
                    update: 'SuperAdmin/EmailOutboxMessages',
                    delete: 'SuperAdmin/EmailOutboxMessages',
                    bulkDelete: 'SuperAdmin/EmailOutboxMessages/bulk-delete',
                    purgeProcessed: 'SuperAdmin/EmailOutboxMessages/purge-processed',
                    purgeAll: 'SuperAdmin/EmailOutboxMessages/purge-all',
                },
            },
        },
        data: {
            bookings: {
                queryKeys: {
                    list: 'SuperAdmin/BookingsList',
                    detail: 'SuperAdmin/BookingDetail',
                },
                endpoints: {
                    list: 'SuperAdmin/Bookings',
                    detail: 'SuperAdmin/Bookings',
                    update: 'SuperAdmin/Bookings',
                    delete: 'SuperAdmin/Bookings',
                },
            },
            orders: {
                queryKeys: {
                    list: 'SuperAdmin/OrdersList',
                },
                endpoints: {
                    list: 'SuperAdmin/Orders',
                },
            },
            apartments: {
                queryKeys: {
                    list: 'SuperAdmin/ApartmentsList',
                    detail: 'SuperAdmin/ApartmentDetail',
                },
                endpoints: {
                    list: 'SuperAdmin/Apartments',
                    detail: 'SuperAdmin/Apartments',
                },
            },
            owners: {
                queryKeys: {
                    list: 'SuperAdmin/OwnersList',
                    detail: 'SuperAdmin/OwnerDetail',
                },
                endpoints: {
                    list: 'SuperAdmin/Owners',
                    detail: 'SuperAdmin/Owners',
                },
            },
            rentCharges: {
                queryKeys: {
                    list: 'SuperAdmin/RentChargesList',
                    detail: 'SuperAdmin/RentChargeDetail',
                },
                endpoints: {
                    list: 'SuperAdmin/RentCharges',
                    detail: 'SuperAdmin/RentCharges',
                },
            },
            lookups: {
                queryKeys: {
                    owners: 'SuperAdmin/DataOwnersLookup',
                    apartments: 'SuperAdmin/DataApartmentsLookup',
                    hotels: 'SuperAdmin/DataHotelsLookup',
                },
                endpoints: {
                    owners: 'SuperAdmin/Data/Owners',
                    apartments: 'SuperAdmin/Data/Apartments',
                    hotels: 'SuperAdmin/Data/Hotels',
                },
            },
        },
        storage: {
            endpoints: {
                privateDownload: 'Storage/Private',
            },
        },
    },
};
